const ZIndexes = {
    HOTSPOT_MODAL_CLOSE_BUTTON: 2004,
    CONTEXT_MENU: 2005,
}

export default ZIndexes
